import styles from './DraggableIndexedTable.module.scss';
import { SortableContainer, SortableHandle, SortableElement } from 'react-sortable-hoc';
import PropTypes from 'prop-types';
import { NO_VALUE_PLACEHOLDER } from '../../../constants/tables';

function DraggableIndexedTable(props) {
  const { columns, list, onSortEnd } = props;
  const TableBodySortable = SortableContainer(({ children }) => <tbody>{children}</tbody>);

  const DragHandle = SortableHandle(({ itemList }) => (
    <tr key={itemList.priority} className={itemList.is_enabled ? styles.draggableStyle : styles.inactive}>
      {columns.slice(1).map((column) => {
        return column.dataField === 'drag_icon' ? (
          <td key={`drag-cell-${itemList.priority}`} style={{ padding: '4px' }}>
            {itemList.is_enabled ? '::' : ''}
          </td>
        ) : (
          <td
            key={`${itemList[column.dataField]}-${itemList.priority}`}
            className={column.classes ? column.classes : ''}
          >
            {column.formatter ? column.formatter(itemList[column.dataField], itemList) : itemList[column.dataField]}
          </td>
        );
      })}
    </tr>
  ));

  const Row = SortableElement(({ itemList }) => <DragHandle itemList={itemList} />);

  return (
    <div className={styles.warehousesTableContainer}>
      <table className={styles.warehousesTableIndexes}>
        <thead>
          <tr>
            <th>{columns[0].text}</th>
          </tr>
        </thead>
        <tbody>
          {list.map((itemList) => {
            return (
              itemList && (
                <tr key={`index-row-${itemList.priority}`}>
                  <td key={`index-cell-${itemList.priority}`} className={columns[0].classes}>
                    {itemList.is_enabled ? itemList.priority : NO_VALUE_PLACEHOLDER}
                  </td>
                </tr>
              )
            );
          })}
        </tbody>
      </table>

      <table className={styles.warehousesTable}>
        <thead>
          <tr>
            {columns.slice(1).map((column) => (
              <th key={column.dataField}>{column.text}</th>
            ))}
          </tr>
        </thead>
        <TableBodySortable onSortEnd={onSortEnd} useDragHandle>
          {list.map((itemList) => {
            return itemList && <Row index={itemList.priority} key={itemList.priority} itemList={itemList} />;
          })}
        </TableBodySortable>
      </table>
    </div>
  );
}
export default DraggableIndexedTable;

DraggableIndexedTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSortEnd: PropTypes.func.isRequired,
};
